import { PROMO_CAMPAIGN_PARTNER_USER_GROUPS } from '../../promo-campaign-access';
import { MenuItem } from '../types';

/**
 * Campaign partner's own view of their voucher campaign.
 *
 * ryd staff reach the same two pages from the ryd Marketing section; this
 * section exists so the partner — who has neither `ryd` as a user group nor the
 * RYD_INTERNAL partner type — sees them at all. Both link to the same routes,
 * and rp-users scopes the data to the campaigns that user's group owns.
 *
 * Deliberately no `requiredPartnerTypes`: a campaign partner is identified by
 * their user group, and pinning a partner type here would silently hide the
 * section the day Stellantis is created with a different one.
 */
const partnerGroups = [...PROMO_CAMPAIGN_PARTNER_USER_GROUPS];

export const voucherCampaignsSection: MenuItem[] = [
  {
    headTitle1: 'Discount Campaign',
    headTitle2: 'Your co-branded ryd campaign',
    sectionId: 'voucher-campaigns',
    type: 'headtitle',
    requiredUserGroup: partnerGroups,
  },
  {
    path: '/voucher-campaigns/registrations',
    title: 'Registrations',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'link',
    active: false,
    // One customer opens as its own page, `…/registrations/<row id>`, with no
    // menu entry of its own — keep this item highlighted while it is open, so a
    // shared link does not land the reader in a sidebar with nothing selected.
    activePathPrefixes: ['/voucher-campaigns/registrations/*'],
    requiredUserGroup: partnerGroups,
    keywords: ['discount', 'campaign', 'voucher', 'registrations', 'approve', 'eligibility'],
  },
  {
    path: '/voucher-campaigns/statistics',
    title: 'Landing Page Statistics',
    icon: 'stroke-landing-page',
    iconf: 'fill-landing-page',
    type: 'link',
    active: false,
    requiredUserGroup: partnerGroups,
    keywords: ['discount', 'campaign', 'voucher', 'statistics', 'landing page', 'visits'],
  },
  {
    path: '/voucher-campaigns/order-statistics',
    title: 'Order Statistics',
    icon: 'stroke-charts',
    iconf: 'fill-charts',
    type: 'link',
    active: false,
    requiredUserGroup: partnerGroups,
    keywords: ['discount', 'campaign', 'voucher', 'orders', 'order statistics', 'redemption'],
  },
  {
    path: '/voucher-campaigns/how-it-works',
    title: 'How It Works',
    icon: 'stroke-learning',
    iconf: 'fill-learning',
    type: 'link',
    active: false,
    requiredUserGroup: partnerGroups,
    keywords: [
      'discount',
      'campaign',
      'voucher',
      'how it works',
      'documentation',
      'process',
      'diagram',
    ],
  },
];
